/**
 * legacy code may alias e.g.:
 *
 *  ```export const ICNInputControlState = BfxInputControlStateEnum;```
 *
 *  ```export type ICNInputControlState = BfxInputControlStateEnum;```
 *
 * may aliased to shorter form:
 *
 * ```import { BfxInputControlStateEnum as EState } from './base-components.enums';```
 *
 * prefer direct use (for simpler search):
 *
 * ```import { BfxInputControlStateEnum } from './base-components.enums';```
 *
 * _never define a new enum that aliases these values_
 */
export enum BfxInputControlStateEnum {
  VALID,
  INVALID,
  ACTIVE,
  INACTIVE,
  NONE,
}
